import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { CarouselModule } from 'ngx-bootstrap/carousel';
import { AppRoutingModule } from './app-routing.module';
import { LayoutComponent } from './components/layout/layout.component';
import { HttpClientModule } from '@angular/common/http';
import { AppComponent } from './app.component';
import { CardComponent } from './components/card/card.component';
import { CardsComponent } from './components/cards/cards.component';
import { CarouselItemComponent } from './components/carousel-item/carousel-item.component';
import { FooterComponent } from './components/footer/footer.component';
import { HeaderModule } from './components/header/header.module';
import { CarouselComponent } from './components/carousel/carousel.component';

@NgModule({
  imports: [
    BrowserModule,
    AppRoutingModule,
    HttpClientModule,
    CarouselModule.forRoot(),
    HeaderModule,
  ],
  declarations: [
    AppComponent,
    LayoutComponent,
    CarouselComponent,
    FooterComponent,
    CardsComponent,
    CardComponent,
    CarouselItemComponent
  ],
  bootstrap: [LayoutComponent],
})
export class AppModule {}
